<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Base Asociados Finadi</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Casos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="filtro.incluirActivos"
              label="Incluir Activos"
              dense></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="filtro.incluirBajas"
              label="Incluir Bajas"
              dense></v-checkbox>
          </v-col>

          <v-col cols="3">
            <v-checkbox
              v-model="filtro.soloCreditosActivos"
              label="Sólo Créditos Activos"
              dense></v-checkbox>
          </v-col>

          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.provincia"
              :items="provincias"
              item-text="nombre"
              item-value="nombre"
              label="Provincia"
              placeholder="Seleccione una provincia"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="filtro.fechaDesde"
              label="Ingreso Desde"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="filtro.fechaHasta"
              label="Ingreso Hasta"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
        </v-row>
        <span class="title">Opciones</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="2" lg="1">
            <v-text-field
              v-model="filtro.separador"
              label="Separador en archivo"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn dark color="green" @click="procesar">
          Descargar&nbsp;
          <v-icon>cloud_download</v-icon>
        </v-btn>
        <div></div>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        incluirActivos: true,
        incluirBajas: false,
        fechaDesde: null,
        fechaHasta: null,
        provincia: "",
        soloCreditosActivos: false,
        separador: ";",
      },
      listEmpresas: [],
      provincias: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadProvincias();
    this.filtro.fechaDesde = this.$moment(new Date()).format("YYYY-MM-DD");
    this.filtro.fechaHasta = this.$moment(new Date()).format("YYYY-MM-DD");
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    componentsLoading: function () {
      return (
        this.loadingCreditosEnMora ||
        this.loadingTelefonos ||
        this.loadingGestionesTelefonicas ||
        this.loadingOtrasGestiones
      );
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id
        );
        this.listEmpresas = result.list.filter((x) => x.id == 2);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async procesar() {
      var self = this;
      console.log(JSON.stringify(this.filtro));
      try {
        self.loading = true;

        await http
          .post(
            "filegeneration/baseasociadosmutual",
            JSON.stringify(this.filtro)
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "BaseAsociadosMutual.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async loadProvincias() {
      this.loading = true;
      try {
        var result = await http.get("provincias"); // traigo todas
        this.provincias = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};
</script>
